export default "__VITE_ASSET__Rs_17zVN__"